<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<style>
</style>

<script>
export default {
  components: {}
};
</script>